var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isFetching
        ? _c("div", [_vm._v(" กำลังดึงข้อมูล ... ")])
        : _vm.setting?.shopBillingInfo?.status === "PENDING" || _vm.isFinished
        ? _c(
            "div",
            {
              staticClass:
                "p-6 min-h-60 flex flex-col gap-6 justify-center items-center bg-white",
            },
            [
              _c("v-icon", { attrs: { color: "primary", size: "100" } }, [
                _vm._v(" mdi-file-clock-outline "),
              ]),
              _c("span", { staticClass: "font-medium text-2xl" }, [
                _vm._v(
                  "กำลังตรวจสอบข้อมูล หากต้องการสอบถามข้อมูลเพิ่มเติม กรุณาติดต่อ LINE @shipnity"
                ),
              ]),
            ],
            1
          )
        : _c(
            "v-form",
            {
              ref: "form",
              staticClass: "flex flex-col gap-3",
              attrs: { readonly: _vm.form.isSubmitting, "lazy-validation": "" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submit()
                },
              },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _vm.setting?.shopBillingInfo?.status === "APPROVED"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "p-6 rounded-lg shadow-md flex flex-col gap-6 justify-center items-center bg-white",
                    },
                    [
                      _c(
                        "v-icon",
                        { attrs: { color: "success", size: "100" } },
                        [_vm._v(" mdi-check-circle-outline ")]
                      ),
                      _c("span", { staticClass: "font-medium text-2xl" }, [
                        _vm._v("อนุมัติการเปิด COD"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.setting?.shopBillingInfo?.status === "REJECTED"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "p-6 rounded-lg shadow-md flex flex-col gap-6 justify-center items-center bg-white",
                    },
                    [
                      _c("v-icon", { attrs: { color: "error", size: "100" } }, [
                        _vm._v(" mdi-close-circle-outline "),
                      ]),
                      _c("span", { staticClass: "font-medium text-2xl" }, [
                        _vm._v(
                          "ไม่อนุมัติการเปิด COD เนื่องจาก " +
                            _vm._s(_vm.setting?.shopBillingInfo?.rejectedReason)
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-radio-group",
                {
                  attrs: {
                    disabled:
                      _vm.setting?.shopBillingInfo?.status === "APPROVED",
                    value: _vm.form.isCompany,
                    row: "",
                    "hide-details": "",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.selectIsCompany($event)
                    },
                  },
                },
                [
                  _c("v-radio", {
                    attrs: { label: "บุคคลธรรมดา", value: false },
                  }),
                  _c("v-radio", { attrs: { label: "นิติบุคคล", value: true } }),
                ],
                1
              ),
              _vm.form.isCompany
                ? _c(
                    "div",
                    {
                      staticClass:
                        "text-lg font-medium text-error px-6 py-3 flex flex-col items-center gap-2 shadow-sm rounded-lg",
                    },
                    [
                      _vm._v(
                        " ชื่อบัญชีธนาคารกับชื่อในหนังสือรับรองต้องตรงกัน "
                      ),
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "text-lg font-medium text-error px-6 py-3 flex flex-col items-center gap-2 shadow-sm rounded-lg",
                    },
                    [_vm._v(" ชื่อบัญชีธนาคารกับชื่อในบัตรประชาชนต้องตรงกัน ")]
                  ),
              _c(
                "div",
                {
                  staticClass:
                    "px-6 py-3 flex flex-col items-center gap-2 shadow-md rounded-lg",
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "text-xl font-medium text-primary self-start",
                    },
                    [_vm._v("เบอร์โทรศัพท์")]
                  ),
                  _c(
                    "div",
                    { staticClass: "flex flex-col" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex gap-1 items-center" },
                        [
                          _c("text-field-label", {
                            attrs: { label: "เบอร์โทรศัพท์" },
                          }),
                          _c("span", { staticClass: "text-error" }, [
                            _vm._v("*"),
                          ]),
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        attrs: {
                          disabled:
                            _vm.setting?.shopBillingInfo?.status === "APPROVED",
                          rules: _vm.rule.telephone,
                          placeholder: "เบอร์โทรศัพท์",
                          dense: "",
                          outlined: "",
                          required: "",
                        },
                        model: {
                          value: _vm.form.tel,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "tel", $$v)
                          },
                          expression: "form.tel",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "px-6 pt-3 pb-6 flex flex-col items-center gap-2 shadow-md rounded-lg",
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "text-xl font-medium text-primary self-start",
                    },
                    [_vm._v("บัญชีธนาคาร")]
                  ),
                  _vm.setting?.shopBillingInfo?.status !== "APPROVED"
                    ? _c(
                        "div",
                        { staticClass: "pb-6 relative flex flex-col" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex gap-1 items-center" },
                            [
                              _c("text-field-label", {
                                attrs: {
                                  label: "หน้าแรกสมุดบัญชีธนาคาร / bookbank",
                                },
                              }),
                              _c("span", { staticClass: "text-error" }, [
                                _vm._v("*"),
                              ]),
                            ],
                            1
                          ),
                          _c("upload", {
                            staticStyle: { width: "300px" },
                            attrs: {
                              "show-delete": Boolean(
                                _vm.form.bookbankPictureUrl
                              ),
                              value: _vm.form.bookbankPictureUrl,
                              name: "bookbankPicture",
                              confirm: false,
                            },
                            on: {
                              remove: _vm.removeBookbankPicture,
                              submit: function ($event) {
                                return _vm.selectBookbankPicture($event.file)
                              },
                            },
                          }),
                          Boolean(_vm.form.bookbankPictureError)
                            ? _c(
                                "span",
                                { staticClass: "absolute bottom-0 text-error" },
                                [_vm._v(_vm._s(_vm.form.bookbankPictureError))]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-full 2xl:flex-row flex flex-col gap-4 2xl:items-start",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-col" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex gap-1 items-center" },
                            [
                              _c("text-field-label", {
                                attrs: { label: "ธนาคาร" },
                              }),
                              _c("span", { staticClass: "text-error" }, [
                                _vm._v("*"),
                              ]),
                            ],
                            1
                          ),
                          _c("v-select", {
                            attrs: {
                              disabled:
                                _vm.setting?.shopBillingInfo?.status ===
                                "APPROVED",
                              items: _vm.banks,
                              "item-text": "name",
                              "item-value": "value",
                              "hide-details": "",
                              dense: "",
                              outlined: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.selectBank($event)
                              },
                            },
                            model: {
                              value: _vm.form.bank,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bank", $$v)
                              },
                              expression: "form.bank",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex flex-col" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex gap-1 items-center" },
                            [
                              _c("text-field-label", {
                                attrs: { label: "เลขบัญชี" },
                              }),
                              _c("span", { staticClass: "text-error" }, [
                                _vm._v("*"),
                              ]),
                            ],
                            1
                          ),
                          _c("v-text-field", {
                            attrs: {
                              disabled:
                                _vm.setting?.shopBillingInfo?.status ===
                                "APPROVED",
                              rules: _vm.rule.required,
                              placeholder: "เลขบัญชี",
                              dense: "",
                              "hide-details": "",
                              outlined: "",
                              required: "",
                            },
                            model: {
                              value: _vm.form.bankAccount,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bankAccount", $$v)
                              },
                              expression: "form.bankAccount",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex flex-col" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex gap-1 items-center" },
                            [
                              _c("text-field-label", {
                                attrs: { label: "ชื่อบัญชี" },
                              }),
                              _c("span", { staticClass: "text-error" }, [
                                _vm._v("*"),
                              ]),
                            ],
                            1
                          ),
                          _c("v-text-field", {
                            attrs: {
                              disabled:
                                _vm.setting?.shopBillingInfo?.status ===
                                "APPROVED",
                              rules: _vm.rule.required,
                              placeholder: "ชื่อบัญชี",
                              dense: "",
                              "hide-details": "",
                              outlined: "",
                              required: "",
                            },
                            model: {
                              value: _vm.form.bankAccountName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bankAccountName", $$v)
                              },
                              expression: "form.bankAccountName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex flex-col" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex gap-1 items-center" },
                            [
                              _c("text-field-label", {
                                attrs: { label: "สาขา" },
                              }),
                              _c("span", { staticClass: "text-error" }, [
                                _vm._v("*"),
                              ]),
                            ],
                            1
                          ),
                          _c("v-text-field", {
                            attrs: {
                              disabled:
                                _vm.setting?.shopBillingInfo?.status ===
                                "APPROVED",
                              rules: _vm.rule.required,
                              placeholder: "สาขา",
                              dense: "",
                              "hide-details": "",
                              outlined: "",
                              required: "",
                            },
                            model: {
                              value: _vm.form.bankAccountBranch,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bankAccountBranch", $$v)
                              },
                              expression: "form.bankAccountBranch",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
              _vm.form.isCompany
                ? _c(
                    "div",
                    {
                      staticClass:
                        "px-6 py-3 flex flex-col items-center gap-2 shadow-md rounded-lg",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-xl font-medium text-primary self-start",
                        },
                        [_vm._v("หนังสือรับรองบริษัท")]
                      ),
                      _vm.setting?.shopBillingInfo?.status !== "APPROVED"
                        ? _c(
                            "div",
                            { staticClass: "pb-6 relative flex flex-col" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex gap-1 items-center" },
                                [
                                  _c("text-field-label", {
                                    attrs: { label: "หนังสือรับรองบริษัท" },
                                  }),
                                  _c("span", { staticClass: "text-error" }, [
                                    _vm._v("*"),
                                  ]),
                                ],
                                1
                              ),
                              _c("upload", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  "show-delete": Boolean(
                                    _vm.form.companyCertPictureUrl
                                  ),
                                  value: _vm.form.companyCertPictureUrl,
                                  name: "companyCertPicture",
                                  confirm: false,
                                },
                                on: {
                                  remove: _vm.removeCompanyCertPicture,
                                  submit: function ($event) {
                                    return _vm.selectCompanyCertPicture(
                                      $event.file
                                    )
                                  },
                                },
                              }),
                              Boolean(_vm.form.companyCertPictureError)
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "absolute bottom-0 text-error",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.form.companyCertPictureError)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              !_vm.form.isCompany
                ? _c(
                    "div",
                    {
                      staticClass:
                        "px-6 py-3 flex flex-col items-center gap-2 shadow-md rounded-lg",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-xl font-medium text-primary self-start",
                        },
                        [_vm._v("รหัสบัตรประชาชน / Passport")]
                      ),
                      _vm.setting?.shopBillingInfo?.status !== "APPROVED"
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex gap-4 justify-between flex-wrap",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pb-6 relative flex flex-col items-center",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex gap-1 items-center" },
                                    [
                                      _c("text-field-label", {
                                        attrs: {
                                          label:
                                            "รูปบัตรประจำตัวประชาชน / Passport ด้านหน้า",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-error" },
                                        [_vm._v("*")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("upload", {
                                    staticStyle: { width: "300px" },
                                    attrs: {
                                      "show-delete": Boolean(
                                        _vm.form.identityCardFrontPictureUrl
                                      ),
                                      value:
                                        _vm.form.identityCardFrontPictureUrl,
                                      name: "identityCardFrontPicture",
                                      confirm: false,
                                    },
                                    on: {
                                      remove:
                                        _vm.removeIdentityCardFrontPicture,
                                      submit: function ($event) {
                                        return _vm.selectIdentityCardFrontPicture(
                                          $event.file
                                        )
                                      },
                                    },
                                  }),
                                  Boolean(
                                    _vm.form.identityCardFrontPictureError
                                  )
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "absolute bottom-0 text-error",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.form
                                                .identityCardFrontPictureError
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "relative pb-6 flex flex-col items-center",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex gap-1 items-center" },
                                    [
                                      _c("text-field-label", {
                                        attrs: {
                                          label:
                                            "รูปคู่บัตรประจำตัวประชาชน / Passport (หน้าแนบบัตร)",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "text-error" },
                                        [_vm._v("*")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("upload", {
                                    staticStyle: { width: "300px" },
                                    attrs: {
                                      "show-delete": Boolean(
                                        _vm.form.identityCardSelfiePictureUrl
                                      ),
                                      value:
                                        _vm.form.identityCardSelfiePictureUrl,
                                      name: "identityCardSelfiePicture",
                                      confirm: false,
                                    },
                                    on: {
                                      remove:
                                        _vm.removeIdentityCardSelfiePicture,
                                      submit: function ($event) {
                                        return _vm.selectIdentityCardSelfiePicture(
                                          $event.file
                                        )
                                      },
                                    },
                                  }),
                                  Boolean(
                                    _vm.form.identityCardSelfiePictureError
                                  )
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "absolute bottom-0 text-error",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.form
                                                .identityCardSelfiePictureError
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "flex flex-col" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex gap-1 items-center" },
                            [
                              _c("text-field-label", {
                                attrs: { label: "บัตรประชาชน / Passport" },
                              }),
                              _c("span", { staticClass: "text-error" }, [
                                _vm._v("*"),
                              ]),
                            ],
                            1
                          ),
                          _c("v-text-field", {
                            attrs: {
                              disabled:
                                _vm.setting?.shopBillingInfo?.status ===
                                "APPROVED",
                              rules: _vm.rule.taxId,
                              placeholder: "บัตรประชาชน / Passport",
                              dense: "",
                              outlined: "",
                              required: "",
                            },
                            model: {
                              value: _vm.form.taxId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "taxId", $$v)
                              },
                              expression: "form.taxId",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass:
                    "px-6 py-3 flex flex-col gap-2 shadow-md rounded-lg",
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "text-xl font-medium text-primary self-start",
                    },
                    [_vm._v("ที่อยู่")]
                  ),
                  _c(
                    "div",
                    { staticClass: "grid grid-cols-1 md:grid-cols-3 gap-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-col" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex gap-1 items-center" },
                            [
                              _c("text-field-label", {
                                attrs: { label: "ที่อยู่" },
                              }),
                              _c("span", { staticClass: "text-error" }, [
                                _vm._v("*"),
                              ]),
                            ],
                            1
                          ),
                          _c("v-text-field", {
                            attrs: {
                              disabled:
                                _vm.setting?.shopBillingInfo?.status ===
                                "APPROVED",
                              rules: _vm.rule.required,
                              placeholder: "ที่อยู่",
                              dense: "",
                              outlined: "",
                              required: "",
                            },
                            model: {
                              value: _vm.form.address,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "address", $$v)
                              },
                              expression: "form.address",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex flex-col" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex gap-1 items-center" },
                            [
                              _c("text-field-label", {
                                attrs: { label: "เขต / ตำบล" },
                              }),
                              _c("span", { staticClass: "text-error" }, [
                                _vm._v("*"),
                              ]),
                            ],
                            1
                          ),
                          _c("v-text-field", {
                            attrs: {
                              disabled:
                                _vm.setting?.shopBillingInfo?.status ===
                                "APPROVED",
                              rules: _vm.rule.required,
                              placeholder: "เขต / ตำบล",
                              dense: "",
                              outlined: "",
                              required: "",
                            },
                            model: {
                              value: _vm.form.subdistrict,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "subdistrict", $$v)
                              },
                              expression: "form.subdistrict",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex flex-col" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex gap-1 items-center" },
                            [
                              _c("text-field-label", {
                                attrs: { label: "อำเภอ" },
                              }),
                              _c("span", { staticClass: "text-error" }, [
                                _vm._v("*"),
                              ]),
                            ],
                            1
                          ),
                          _c("v-text-field", {
                            attrs: {
                              disabled:
                                _vm.setting?.shopBillingInfo?.status ===
                                "APPROVED",
                              rules: _vm.rule.required,
                              placeholder: "อำเภอ",
                              dense: "",
                              outlined: "",
                              required: "",
                            },
                            model: {
                              value: _vm.form.district,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "district", $$v)
                              },
                              expression: "form.district",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex flex-col" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex gap-1 items-center" },
                            [
                              _c("text-field-label", {
                                attrs: { label: "จังหวัด" },
                              }),
                              _c("span", { staticClass: "text-error" }, [
                                _vm._v("*"),
                              ]),
                            ],
                            1
                          ),
                          _c("v-text-field", {
                            attrs: {
                              disabled:
                                _vm.setting?.shopBillingInfo?.status ===
                                "APPROVED",
                              rules: _vm.rule.required,
                              placeholder: "จังหวัด",
                              dense: "",
                              outlined: "",
                              required: "",
                            },
                            model: {
                              value: _vm.form.province,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "province", $$v)
                              },
                              expression: "form.province",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "flex flex-col self-start" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex gap-1 items-center" },
                            [
                              _c("text-field-label", {
                                attrs: { label: "รหัสไปรษณีย์" },
                              }),
                              _c("span", { staticClass: "text-error" }, [
                                _vm._v("*"),
                              ]),
                            ],
                            1
                          ),
                          _c("snt-number-field", {
                            attrs: {
                              disabled:
                                _vm.setting?.shopBillingInfo?.status ===
                                "APPROVED",
                              min: 0,
                              rules: _vm.rule.required,
                              rounded: "",
                            },
                            model: {
                              value: _vm.form.postcode,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "postcode", $$v)
                              },
                              expression: "form.postcode",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
              _vm.setting?.shopBillingInfo?.status !== "APPROVED"
                ? _c("save-change-button", {
                    staticClass: "self-end",
                    attrs: {
                      disabled: _vm.form.isSubmitting || _vm.isFetching,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.submit()
                      },
                    },
                  })
                : _vm._e(),
              _c("v-form"),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }